import React, { useState } from "react";
import { MoneyInput } from "../../../components/MoneyInput";
import { Loader2 } from "lucide-react";

export function PriceDialog({ m, onClose, onSave, busy }) {
  const isImg = m.kind === "image"; const tok = m.billing === "tokens"; const field = tok ? "usd_per_1k_tokens" : "usd_per_sec";
  const [img, setImg] = useState(String(m.usd_per_image ?? ""));
  const [sec, setSec] = useState(Object.fromEntries(Object.entries(m[field] || {}).map(([k, v]) => [k, String(v)])));
  const keys = Object.keys(m[field] || {}).length ? Object.keys(m[field]) : m.resolutions || [];
  const imgNum = Number(img);
  const imgErr = isImg && (img === "" || Number.isNaN(imgNum) || imgNum < 0 || imgNum > 10) ? "Harga harus 0–10 USD" : "";
  const secErr = !isImg && keys.some((k) => sec[k] === "" || sec[k] == null || Number.isNaN(Number(sec[k])) || Number(sec[k]) < 0) ? "Isi semua resolusi dengan angka ≥ 0" : "";
  const submit = (e) => {
    e.preventDefault();
    if (imgErr || secErr) return;
    onSave(isImg ? { usd_per_image: imgNum } : { [field]: Object.fromEntries(keys.map((k) => [k, Number(sec[k])])) });
  };
  return (
    <div className="dialog-backdrop" onClick={onClose} data-testid="llm-price-dialog">
      <form className="dialog-panel" onClick={(e) => e.stopPropagation()} onSubmit={submit}>
        <h2 className="text-base font-bold text-slate-900">Harga provider · {m.label}</h2>
        <p className="mt-1 text-xs text-slate-500">Harga list provider (USD). Kredit pengguna dihitung otomatis dari harga ini × margin fitur × pajak.</p>
        {isImg ? (
          <label className="mt-4 block text-xs font-semibold text-slate-600">USD per gambar (kualitas dasar)
            <MoneyInput currency="USD" decimals={4} value={img} onValue={setImg} className="mt-1" testid="llm-price-image" />
          </label>
        ) : keys.map((k) => (
          <label key={k} className="mt-4 block text-xs font-semibold text-slate-600">{tok ? "USD per 1K token" : "USD per detik"} · {k}
            <MoneyInput currency="USD" decimals={tok ? 6 : 4} value={sec[k] ?? ""} onValue={(v) => setSec((s) => ({ ...s, [k]: v }))} className="mt-1" testid={`llm-price-${tok ? "tok" : "sec"}-${k}`} />
          </label>
        ))}
        {tok && <p className="mt-3 rounded-lg bg-slate-50 px-3 py-2 text-[11px] text-slate-500" data-testid="llm-price-token-help">Token = lebar × tinggi × 24 fps × (detik output + detik video referensi) ÷ 1024. Ada video referensi → tarif × {m.ref_video_factor ?? 1}.</p>}
        {(imgErr || secErr) && <p className="mt-2 text-xs font-semibold text-rose-600" data-testid="llm-price-error">{imgErr || secErr}</p>}
        <div className="mt-6 flex justify-end gap-2">
          <button type="button" onClick={onClose} className="btn-soft rounded-xl px-4 py-2 text-xs font-bold" data-testid="llm-price-cancel">Batal</button>
          <button type="submit" disabled={busy || !!imgErr || !!secErr} className="btn-primary inline-flex items-center gap-1.5 rounded-xl px-4 py-2 text-xs font-bold disabled:opacity-50" data-testid="llm-price-save">{busy && <Loader2 size={12} className="animate-spin" />} Simpan</button>
        </div>
      </form>
    </div>
  );
}
